'use client'

import { redirect } from 'next/navigation'
import { useEffect } from 'react'

const Home = (): JSX.Element => {
  useEffect(() => {
    const token = window?.localStorage.getItem('token')
    if (token === null) {
      redirect('/login')
    } else if (window?.location.pathname === null || window?.location.pathname === '' || window?.location.pathname === '/') {
      redirect('/admin-user-management')
    } else {
      redirect(window?.location.pathname + window?.location.search)
    }
  }, [])

  return <></>
}

export default Home
